declare global {
  interface Window {
    grecaptcha: any;
  }
}

export const useRecaptcha = () => {
  const { recaptchaKey } = useRuntimeConfig().public;
  const reCaptchaToken = ref<string>("");
  const { load, status } = useScript(
    {
      src: `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`,
      crossorigin: false,
    },
    {
      trigger: "manual",
    }
  );

  const execute = async (action: string) => {
    reCaptchaToken.value = localStorage.getItem("reCaptchaToken") || "";
    if (!reCaptchaToken.value) {
      reCaptchaToken.value = await getToken(action);
    }
  };

  const loadRecaptchaScript = async () => {
    if (!window.grecaptcha) {
      await load().catch((error) => {
        console.error("reCaptcha failed", error);
        return Promise.reject(error);
      });
    }
    return window.grecaptcha;
  };

  const getToken = async (action: string): Promise<string> => {
    const grecaptcha = await loadRecaptchaScript().catch((error) => {
      throw error;
    });
    try {
      return new Promise((resolve, reject) => {
        grecaptcha.ready(async () => {
          try {
            const token = await grecaptcha.execute(recaptchaKey, {
              action,
            });
            resolve(token);
          } catch (error) {
            reject(error);
          }
        });
      });
    } catch (error) {
      console.error("reCaptcha failed", error);
      return Promise.reject(error);
    }
  };

  return { reCaptchaToken, execute };
};
